import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';
import SelfServeCheckoutSessionUIService from '@/modules/billing/services/SelfServeCheckoutSessionUIService';
import { Route, RouteRecord } from 'vue-router';
import { EstateRoute } from '@/modules/estate/constants/EstateRoute';

export class PaidPlanRouteConfig extends CurrentEstateRouteConfig {
  canAccessRoute(): boolean {
    return true;
  }

  onRedirect(to: Route, from: Route): void {
    if (this.canAccessRoute()) {
      return;
    }

    const parent: RouteRecord = from.matched?.at(-1);

    if (parent) {
      SelfServeCheckoutSessionUIService.showSelfServePlanModal({
        parent: parent.instances.default,
        successUrl: getters.auth.getUser()?.currentEstate?.isBasicPlan
          ? `${window.location.origin}/${EstateRoute.DASHBOARD}?show_redirect=true`
          : undefined
      });
    }
  }
}
